import { render, staticRenderFns } from "./promoSection.vue?vue&type=template&id=00721d99&scoped=true&"
import script from "./promoSection.vue?vue&type=script&lang=js&"
export * from "./promoSection.vue?vue&type=script&lang=js&"
import style0 from "./promoSection.vue?vue&type=style&index=0&id=00721d99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00721d99",
  null
  
)

export default component.exports